<template>
  <div class="sp-alert-content">
    <div class="content-slot">
      <div><slot></slot></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "sp-alert-content";
.content-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
